var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#85D1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9402 30.5H26.1902M26.6152 24.8274C28.6254 23.8725 30.0152 21.8235 30.0152 19.45C30.0152 16.1639 27.3513 13.5 24.0652 13.5C20.7791 13.5 18.1152 16.1639 18.1152 19.45C18.1152 21.8235 19.505 23.8725 21.5152 24.8274V25.4C21.5152 26.1921 21.5152 26.5882 21.6446 26.9006C21.8172 27.3171 22.1481 27.6481 22.5647 27.8206C22.8771 27.95 23.2731 27.95 24.0652 27.95C24.8573 27.95 25.2534 27.95 25.5658 27.8206C25.9823 27.6481 26.3133 27.3171 26.4858 26.9006C26.6152 26.5882 26.6152 26.1921 26.6152 25.4V24.8274Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSolutions);
export default __webpack_public_path__ + "static/media/active-solutions.0d29d7f73c9b46463f3717753a56bf78.svg";
export { ForwardRef as ReactComponent };